export default __webpack_public_path__ + "static/media/COA.76e02aea.png";